/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTaskDependenciesQuery } from '../../models/get-project-task-dependencies-query';
import { GetProjectTaskDependenciesQueryResult } from '../../models/get-project-task-dependencies-query-result';

export interface ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Params {
      body?: GetProjectTaskDependenciesQuery
}

export function apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTaskDependenciesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTaskDependenciesQueryResult>;
    })
  );
}

apiProjectTaskDependencyGetProjectTaskDependenciesPost$Plain.PATH = '/api/ProjectTaskDependency/GetProjectTaskDependencies';
